import React from "react";
import Banner from "./Banner";
import Trusted from "./Trusted";
import dynamic from "next/dynamic";
const CRMServices = dynamic(() => import("./ServicesCRM"),{ssr: true});
const CRMSystem = dynamic(() => import("./crm-solutions"),{ssr: true});
const Methodologies = dynamic(() => import("./methodologies"),{ssr: true});
const HocHead = dynamic(() => import("@/Components/HigherOrderComponent/HocHead"),{ssr: true});
const RequestProposalSolution = dynamic(() => import("./Client-solution"),{ssr: true});
const WhyTrootech = dynamic(() => import("./whytrootech"),{ssr: true});
const Faq = dynamic(() => import("../Home/Faq"),{ssr: true});
const GameChanger = dynamic(() => import("./GameChanger"),{ssr: true});

import { RFPFormBlock } from "../Home";
const RFPForm = dynamic(() => import("./Quote"),{ssr: true});

interface SoftwareSolutionProps {
  slug?: any;
  data?: any;
  seo?: any;
  isMobile?: boolean;
  breadcrumbs?: any
}

const SoftwareSolution: React.FC<SoftwareSolutionProps> = ({ data, isMobile, seo, breadcrumbs }) => {
  const blocks = data;

  return (
    <>
      {seo && <HocHead seo={seo} />}
      <div>
        <div>
          {blocks?.map((block: any, i: number) => {
            switch (block?.__component) {
              case "blocks.2025-software-solution-banner":
                return <Banner key={i} data={block} isMobile={isMobile} breadcrumbs={breadcrumbs} />;
              case "blocks.2025-home-trusted-by":
                return <Trusted key={i} data={block as any} />;
              case "blocks.2025-crm-services":
                return <CRMServices key={i} data={block} isMobile={isMobile} />;
              case "blocks.2025-crm-solutions":
                return <CRMSystem key={i} data={block} isMobile={isMobile} />;
              case "blocks.crm-services-methodologies":
                return (
                  <Methodologies key={i} data={block} isMobile={isMobile} />
                );
              case "blocks.2025-solution-game-changer":
                return <GameChanger key={i} data={block} isMobile={isMobile} />;
              case "blocks.2025-rfp-case-studies":
                return <RequestProposalSolution key={i} data={block as any} />;
              case "blocks.why-trootech":
                return <WhyTrootech key={i} data={block} isMobile={isMobile} />;
              case "blocks.2025-home-fa-qs":
                return <Faq key={i} data={block} />;
              case "blocks.2025-home-rfp":
                return <RFPForm key={i} data={block as RFPFormBlock} />;
              default:
                return (
                  <div
                    key={i}
                    className="text-red-500 p-4 bg-red-50 border border-red-200 rounded-md mt-4 max-w-[1500px] mx-auto"
                  >
                    Unknown block type: {block?.__component || "undefined"}
                  </div>
                );
            }
          })}
        </div>
      </div>
    </>
  );
}

export default SoftwareSolution;
